var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOpenLink = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0v1H2a1 1 0 00-1 1v9a1 1 0 001 1h9a1 1 0 001-1V7h1v4a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2h4zm7 0v4h-1V1.75L6.904 6.843a.53.53 0 11-.75-.75L11.25 1H9V0h4z"
  })));
});
export default SvgOpenLink;